module.exports = __webpack_public_path__ + "fonts/33a429d.TTF";